import Table from './Table';
import TableHeader from './TableHeader';
import TableBody from './TableBody';
import TableFooter from './TableFooter';
import TableRow from './TableRow';
import TableHeaderCell from './TableHeaderCell';
import TableDataCell from './TableDataCell';

export const EspressoTable = {
	Table,
	TableHeader,
	TableBody,
	TableRow,
	TableFooter,
	TableHeaderCell,
	TableDataCell,
};

export * from './ResponsiveTable';
export * from './utils';
export * from './types';
